if (!customElements.get('product-favorite')) {
  customElements.define('product-favorite', class extends HTMLElement {
    connectedCallback() {
      this.key = `asansara:favorite:${this.dataset.productId}`;
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      this.hidden = false;
      this.sync();
      this.button.addEventListener('click', this.toggle);
      window.addEventListener('storage', this.onStorage);
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.toggle);
      window.removeEventListener('storage', this.onStorage);
    }
    sync() {
      let saved = false;
      try { saved = localStorage.getItem(this.key) === '1'; } catch { /* Storage can be disabled. */ }
      this.button.setAttribute('aria-pressed', String(saved));
      this.button.setAttribute('aria-label', saved ? this.dataset.unsave : this.dataset.save);
    }
    onStorage = (event) => { if (event.key === this.key || event.key === null) this.sync(); };
    toggle = () => {
      try {
        const saved = localStorage.getItem(this.key) !== '1';
        if (saved) localStorage.setItem(this.key, '1');
        else localStorage.removeItem(this.key);
        this.sync();
        this.status.textContent = saved ? this.dataset.saved : this.dataset.removed;
      } catch { this.status.textContent = this.dataset.error; }
    };
  });
}
